module.exports = __webpack_public_path__ + "static/media/papillon_trade_logo.9cc9af18.png";